import { render, staticRenderFns } from "./ItemPlannerItemAlternativeDateSuggestion.vue?vue&type=template&id=62aa8cc2&scoped=true&"
import script from "./ItemPlannerItemAlternativeDateSuggestion.vue?vue&type=script&lang=js&"
export * from "./ItemPlannerItemAlternativeDateSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./ItemPlannerItemAlternativeDateSuggestion.vue?vue&type=style&index=0&id=62aa8cc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa8cc2",
  null
  
)

export default component.exports